import React  from 'react';
import { Handle, Position, NodeResizer } from 'reactflow';

const DefaultNode = ({ data, selected }) => {

    return (
        <div className="default-node" style={{ position: 'relative', padding: '0px' }}>
            <NodeResizer isVisible={selected} /> {/* Enable resizing */}
            <div className="resizable-node">
                {data.label}
            </div>
            <Handle type="source" position={Position.Right} id="right" style={{ background: '#000' }} />
            <Handle type="source" position={Position.Left} id="left" style={{ background: '#000' }} />
            <Handle type="target" position={Position.Top} id="top" style={{ background: '#777' }} />
            <Handle type="target" position={Position.Bottom} id="bottom" style={{ background: '#777' }} />

        </div>
    );
};

export default DefaultNode;